import React from 'react';
import ReactDOM from 'react-dom/client';
import { initTheme, ThemeProvider } from './hooks/useTheme';
import './index.css';
import "./styles/grid.css"
import "./styles/globals.css"
import "./styles/mobile-admin.css"
import "./styles/data-table-mobile.css"
import "./styles/Home.module.css"
import "./styles/style.css"
import { Toaster } from "./components/ui";
import MyRouter from './config/routes';
import reportWebVitals from './reportWebVitals';
import { persistor, store } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux'
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'




const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 10,
    },
  },
})

initTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <MyRouter />
            <Toaster
              position="bottom-right"
              closeButton
              offset={20}
              visibleToasts={5}
              style={{ zIndex: 99999 }}
              toastOptions={{
                className: "admin-toast",
              }}
            />
          </PersistGate>
        </Provider>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
